import { useQuery } from "react-query";
import axios from "axios";

const doAction = async (path, id) => {
  const onsiteHeader = {
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${id}`,
    },
  };
  try {
    const res = await axios.get(path, onsiteHeader);
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

const useActivateInit = (path, id) => {
  return useQuery(["com-init-get", path, id], () => doAction(path, id), {
    staleTime: 1 * 60 * 1000, // Data will be considered stale after 5 minutes
    retry: 2, // If the query fails, it will retry up to 3 times
  });
};

export default useActivateInit;
